import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MobileDelegateService } from '../../../core/services/mobile-delegate.service';
import { MobileWebViewService } from '../../../core/services/mobile-web-view.service';
import { MetaMapVerificationEvent } from '../../model/kamonal-model';
import { DelegateType } from '../../../shared/models/utility.model';

@Component({
    selector: 'app-custom-meta-map-button',
    templateUrl: './custom-meta-map-button.component.html',
    styleUrls: ['./custom-meta-map-button.component.scss'],
})
export class CustomMetaMapButtonComponent implements OnInit {
    @ViewChild('KamonaMetaMap') kamonaMetaMap: ElementRef;
    @Output() emitClickEvent = new EventEmitter();
    @Output() emitLoadEvent = new EventEmitter();
    @Output() emitUserFinishedEvent = new EventEmitter();
    @Output() emitExitedEvent = new EventEmitter();
    @Output() emitUserStartedSdk = new EventEmitter();
    @Input() text = 'Verify';
    @Input() reference: string;
    @Input() useWebSdk = true;
    @Input() isCheckingApiMetaMapRef = false;
    submitting: boolean;
    @Input() flowId = '63bd31422afaa3001c941354';
    @Input() clientId = '62332ccfe04004001cf3577c';
    @Input() metadata = '';
    @Input() useExternalClickAction: boolean;

    constructor(private delegateService: MobileDelegateService, private mobileService: MobileWebViewService, private cd: ChangeDetectorRef) {}

    ngOnInit(): void {}

    startWebSdk() {
        this.kamonaMetaMap?.nativeElement?.click();
    }

    submitV2(metadata) {
        this.metadata = metadata;
        this.setMetaDataAttribute(metadata);
        this.cd.detectChanges();
        this.submit();
    }

    getMobileMetadata() {
        let metadata = this.metadata;
        try {
            metadata = JSON.parse(metadata);
        } catch (error) {
            metadata = '';
            this.submitting = false;
        }
        return metadata;
    }

    setMetaDataAttribute(metadata) {
        this.kamonaMetaMap?.nativeElement?.setAttribute('metadata', `${metadata}`);
    }

    submit() {
        this.useExternalClickAction ? this.clicked() : this.handleOnClick();
    }

    handleOnClick() {
        this.submitting = true;
        this.useWebSdk ? this.startWebSdk() : this.handleMobileSdk();
    }

    clicked() {
        this.emitClickEvent.emit();
    }

    loaded() {
        this.emitLoadEvent.emit();
    }

    started() {
        this.emitUserStartedSdk.emit();
    }

    finished() {
        this.submitting = false;
        this.emitUserFinishedEvent.emit();
    }

    verificationCallback($event: MetaMapVerificationEvent) {
        switch ($event) {
            case MetaMapVerificationEvent.exitedSdk:
                this.exited();
                return;
            case MetaMapVerificationEvent.userStartedSdk:
                this.started();
                return;
            case MetaMapVerificationEvent.loaded:
                this.loaded();
                return;
            case MetaMapVerificationEvent.userFinishedSdk:
                this.finished();
                return;
        }
    }

    handleMobileSdk() {
        const isAppUpdateNeeded = this.isAppUpdateNeeded();
        if (isAppUpdateNeeded) {
            this.handleAppUpdate();
            return;
        }
        this.startMobileSdk();
    }

    startMobileSdk() {
        const metadata = this.getMobileMetadata();
        this.delegateService
            .setDelegateData(DelegateType.launchMetaMapFlow, metadata, `${this.flowId}`)
            .then((res) => {
                this.handleMobileSdkResponse(res);
            })
            .catch((error) => {
                this.exited();
            });
    }

    handleMobileSdkResponse(res) {
        try {
            const response = JSON.parse(res);
            const incompleteMetaMap = response?.status === 'FAILED';
            incompleteMetaMap ? this.exited() : this.finished();
        } catch (err) {
            console.log(`Error from meta ${JSON.stringify(err)}`);
        }
    }

    isAppUpdateNeeded() {
        const appVersionNumber = this.mobileService.getMobileAppVersion() || this.mobileService.getMoniepointAppParameters()?.appVersion;
        const isUpdate = this.mobileService.isAppLowerVersion(this.mobileService.LIVELINESS_APP_VERSION, `${appVersionNumber}`);
        return isUpdate && this.mobileService.isMobileWebViewUser();
    }

    handleAppUpdate() {
        this.mobileService.launchUpdateAppModal();
        this.exited();
    }

    exited() {
        this.submitting = false;
        this.emitExitedEvent.emit();
    }
}
